import  DatePicker  from 'element-ui/lib/date-picker';
import  elButton  from 'element-ui/lib/button';
import 'element-ui/lib/theme-chalk/date-picker.css';
import 'element-ui/lib/theme-chalk/button.css';
import 'element-ui/lib/theme-chalk/icon.css';
import blessingBagDetail from "../blessingBagDetail/blessingBagDetail.vue";
import luckList from "../luckBagMemsList/luckBagMemsList.vue";

import { Component , Vue , Watch ,Prop} from "vue-property-decorator";
Vue.component('el-date-picker',DatePicker)
Vue.component('el-butten',elButton)
@Component({
	components: { blessingBagDetail ,luckList}
})
export default class activityModal extends Vue {
    @Prop() private roomData!: any;
    params:any={
        baseId:'',
        sceneId:'',
        pageNum:1,
        pageSize:30,
        createStartTime: '',
        createEndTime: '',
        luckyName: '',
        luckyStatus: '-1' //活动状态  -1 查询所有 1-待审核 2-审核通过 3-待开始 4-进行中 5-已结束 10-删除
    }
    auditStatus:object= {
        '-1':'全部',
        '1':'待开始',
        '2':'进行中',
        '3':'结束',
        '5':'删除',
    }
    activityType:object= {
        '1':'优惠券',
        '2':'奖励金',
    }
    createTimes:any=''
    activityItem:any={//选中活动数据

    }
    activityData:any=[]
    isBlessingBagManage:boolean = true // 弹窗boolean
    isActivityDetail:boolean = false //是否显示详情
    isLuckList:boolean = false //是否显示中奖纪录
	api:any={
        luckyBagMemsListApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luckyBag/luckyMemsList",//活动中奖纪录查询
        luckyBagListApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luckyBag/luckyBagList?",
	}
    @Watch('isBlessingBagManage') 
	onChange(val:any,oldVal:any){
        if(!val){
            this.$emit('hintChange' , {name:'isBlessingBagManage',val:val})
        }
	}
	mounted() {
        
        console.log(this.roomData);
        this.params.baseId = this.$route.params.id
        this.params.sceneId = this.roomData.scene_id
		this.getactivityListData(true)
	}

	getactivityListData(init:boolean){//获取福袋活动列表
        let url = this.api.luckyBagListApi
        let activityStatus:any = this.$refs.activityStatus
        this.params.luckyStatus = activityStatus.value        
        if (this.createTimes) {
            this.params.createStartTime = this.createTimes[0]
            this.params.createEndTime = this.createTimes[1]
        }else{
            this.params.createStartTime = ''
            this.params.createEndTime = ''
        }
        for (const key in this.params) {
            if (Object.prototype.hasOwnProperty.call(this.params, key)) {
                const par = this.params[key];
                url += `&${key}=${par}`
            }
        }
		this.fetch({
			url: url,
			method: "get",
		}).then((res:any) => {
            if (init && (!res.data || res.data.length == 0)) {
                this.isActivityDetail = true
            }
            this.activityData = res.data
		})	
	}
    closeDetail(query:boolean){//关闭创建活动页面
        this.isActivityDetail = false
        if (query) {
            this.getactivityListData(false)
        }
    }
    closeLuckList(){//关闭创建活动页面
        this.isLuckList = false
    }
    luckyBagMemsListPop(act:any){//获取中奖纪录
        this.activityItem = act?act:{}
        this.isLuckList = true
    }
    changeActivity(act:any){//创建/查看/修改活动
        this.activityItem = act?act:''
        this.isActivityDetail = true
    }
    search(){
        this.params.pageNum = 1
        this.getactivityListData(false)
    }
}
